import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import type { SaleEventProps } from './useSaleEvent';
import YearlyDiscountChip from './YearlyDiscountChip';

interface PriceProps {
  price: string;
  oldPrice?: string;
  withRadioSelection?: boolean;
  billingCycle?: 'single' | 'monthly' | 'yearly';
  matchingSaleEvent?: SaleEventProps;
}
interface StyleProps {
  additional: any;
}

const useStyles = makeStyles<StyleProps>()((_theme, props) => ({
  oldPrice: {
    textDecoration: 'line-through',
  },
  prices: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  price: {
    textAlign: 'right',
    fontSize: 24,
    fontWeight: 600,
    ...(props.additional?.price as React.CSSProperties),
  },
  yearlyDescription: {
    fontSize: 11,
    textAlign: 'right',
    lineHeight: 0.8,
    color: '#ffffffb0',
  },
}));

const Price: React.FC<PriceProps> = ({
  price,
  oldPrice,
  billingCycle,
  withRadioSelection,
  matchingSaleEvent,
}) => {
  const { classes } = useStyles({ additional: matchingSaleEvent?.styles });
  const { t } = useTranslation();
  return (
    <div className={classes.prices}>
      {billingCycle === 'yearly' && !withRadioSelection && !matchingSaleEvent && (
        <YearlyDiscountChip />
      )}
      {oldPrice && <div className={classes.oldPrice}>{oldPrice}</div>}
      <div className={classes.price}>{price}</div>
      {billingCycle === 'yearly' && (
        <div className={classes.yearlyDescription}>
          {withRadioSelection
            ? t('home.pricing.per_month')
            : t('home.pricing.per_month_billed_yearly')}
        </div>
      )}
      {billingCycle === 'monthly' && !withRadioSelection && (
        <div className={classes.yearlyDescription}>{t('home.pricing.per_month')}</div>
      )}
    </div>
  );
};

export default Price;
